import BaseSetup from '@/components/BaseSetup';
import { i18n } from '@/i18n';
import { Reactive } from '@/utils/decorators';
import { watch } from 'vue';

export type SharedStepperEmits = {
	(e: 'update:modelValue', val: string): void
};

export type SharedStepperProps = {
	clickable?: boolean
	withChevron?: boolean
	steps?: Armado.SharedStepperStep[]
	modelValue?: string
};

export default class SharedStepperSetup extends BaseSetup {

	static readonly defaultProps = {
		steps: () => [
			{
				label: i18n.global.t('common.firstStep'),
				name: 'first',
			},
		],
		modelValue: 'first',
	};

	@Reactive private readonly state = { maxPossibleStepIndex: 0 };

	private get indexOfActiveStep () { return (this.props.steps ?? []).findIndex((x: Armado.SharedStepperStep) => x.name === this.activeStep) }

	private get activeStep () { return this.props.modelValue }
	private set activeStep (val) {
		if (val) this.emits('update:modelValue', val);
	}

	constructor (
		private props: SharedStepperProps,
		private emits: SharedStepperEmits,
	) {
		super();

		watch(() => this.indexOfActiveStep, (val: number) => {
			if (val > this.state.maxPossibleStepIndex) {
				this.state.maxPossibleStepIndex = val;
			}
		});
	}

	protected onMounted (): void {
		this.state.maxPossibleStepIndex = this.indexOfActiveStep;
	}

	stepIsActive (value: string) {
		return this.activeStep === value;
	}

	stepIsPassed (value: number) {
		return value <= this.state.maxPossibleStepIndex;
	}

	stepIsMax (value: number) {
		return this.state.maxPossibleStepIndex === value;
	}

	goToStep (step: Armado.SharedStepperStep, index: number) {
		if (!this.props.clickable) return;
		if (index > this.state.maxPossibleStepIndex) return;
		this.activeStep = step.name;
	}

}
